<template>
  <div
    id="tab-container"
    :class="{ isVertical: vertical, 'is-tab': isTab }"
  >
    <div
      v-for="tab in tabs"
      :key="tab.key"
      class="tab"
      :class="{ active: activeKey === tab.key }"
      @click="selectTab(tab.key)"
    >
      {{ tab.text }}
    </div>
  </div>
</template>

<script>
// bind with v-model in parent component
export default {
  /*
    tabs: [
        {key: x, text: y}
    ],
    activeKey: x
   */
  model: {
    prop: 'activeKey',
    event: 'change',
  },
  props: {
    tabs: Array,
    activeKey: [String, Number],
    isTab: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectTab(key) {
      this.$emit('change', key);
    },
  },
};
</script>

<style scoped lang="scss">
// @import 'dv/lib/SASS/_vars.scss';

#tab-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  &.is-tab {
    display: block;
    @media screen and (max-width: $phone-width) {
      display: flex;
      .tab {
        flex: 1 1 10%;
      }
    }
    .tab {
      display: inline-block;
      margin-right: 3px;
      border-radius: 3px 3px 0 0;
      border: 0;
    }
  }
  .tab {
    flex: 1 1 10%;
    text-align: center;
    padding: 7px;
    border-right: 1px solid $indBlue;
    background-color: $inactiveBG;
    color: $inactiveText;
    cursor: pointer;
    &.active {
      background: $indBlue;
      color: white;
    }
    &:hover:not(.active) {
      background: $inactiveBGHover;
      // color: white;
    }
    &:last-child {
      border-right: 0;
    }
  }

  &.isVertical {
    flex-direction: column;
    .tab {
      border-right: 0;
      border-bottom: 1px solid $indBlue;
      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
</style>
